import React from 'react';
import css from './FeedDocumentAttachment.module.css';
import ProfileIconCard from '../../../../components/ProfileIconCard/ProfileIconCard';
const FeedDocumentAttachment = props => {
  const { attachments = [], inline_attachments = [] } = props;

  const isDocumentAttachment = attachment =>
    attachment?.content_type?.startsWith('application/') ||
    /\.(pdf|doc|docx|xls|xlsx|ppt|pptx|txt)$/i.test(attachment?.filename || attachment?.url || '');

  const renderAttachments = attachmentList =>
    attachmentList
      ?.filter(attachment => attachment?.type !== 'embed')
      ?.map((attachment, index) => {
        if (isDocumentAttachment(attachment)) {
          const href = attachment?.url || attachment?.thq_media_url;
          if (!href) return null;
          return (
            <a
              key={index}
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              className={css.attachmentLink}
            >
              <span className={css.attachmentIcon}>
                <ProfileIconCard type="document" />
              </span>
              {attachment?.filename || 'Document'}
            </a>
          );
        }
        return null; // Skip invalid items
      });

  const hasAttachments =
    attachments.some(isDocumentAttachment) || inline_attachments.some(isDocumentAttachment);

  return hasAttachments ? (
    <div className={css.attachmentList}>
      {renderAttachments(attachments)}
      {renderAttachments(inline_attachments)}
    </div>
  ) : null;
};

export default FeedDocumentAttachment;
